import { render, staticRenderFns } from "./ProcessAction.vue?vue&type=template&id=290180d8&scoped=true"
import script from "./ProcessAction.vue?vue&type=script&lang=js"
export * from "./ProcessAction.vue?vue&type=script&lang=js"
import style0 from "./ProcessAction.vue?vue&type=style&index=0&id=290180d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290180d8",
  null
  
)

export default component.exports